const RESHARE_ATTRIBUTION =
  /^\s*(?:Original post by|Shared from)\s+@[a-zA-Z0-9_.]+\s*$/i;
const RESHARE_SOURCE =
  /https?:\/\/[^\s<]+#(?:wlb-author=|wlb-reshare=|wlb-r=|wlb-reshare-source)[^\s<]*/i;

export interface EditableReshareContent {
  thoughts: string;
  protectedContent: string;
}

/**
 * Separates the member's editable thoughts from the original-post snapshot and
 * source metadata. The protected portion must never be shown in the editor.
 */
export const splitEditableReshareContent = (
  text: string,
): EditableReshareContent | null => {
  const lines = text.split(/\r?\n/);
  const sourceIndex = lines.findIndex(line => RESHARE_SOURCE.test(line));
  if (sourceIndex < 0) return null;

  let attributionIndex = -1;
  for (let index = sourceIndex - 1; index >= 0; index -= 1) {
    if (RESHARE_ATTRIBUTION.test(lines[index] ?? '')) {
      attributionIndex = index;
      break;
    }
  }
  if (attributionIndex < 0) return null;

  return {
    thoughts: lines.slice(0, attributionIndex).join('\n').trim(),
    protectedContent: lines.slice(attributionIndex).join('\n').trim(),
  };
};

/** Reattaches the untouched original-post data after an edited thought. */
export const rebuildEditedReshareContent = (
  thoughts: string,
  protectedContent: string,
): string => {
  const cleanThoughts = thoughts.trim();
  const cleanProtectedContent = protectedContent.trim();
  return cleanThoughts
    ? `${cleanThoughts}\n\n${cleanProtectedContent}`
    : cleanProtectedContent;
};
